module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats"
  }, [_vm._v("\n    Statistik\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a2f4210"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/stats.vue
// module id = 290
// module chunks = 1